import React from 'react';
import PropTypes from 'prop-types';
import {
    LEGEND_SECTION_READ_MODE,
    READING_STATS_LABELS,
} from '../../../../../../constants/reading/TroConstants';
import RescoringLegend from '../rescoringLegend/RescoringLegend';
import './ErrorSection.scss';
import { generateReactKey } from '../../../../../../utils/shared/commonUtils';

const ErrorSection = ({ readingStats, isUntranscribable }) => (
    <section className="tro-errors">
        <h5 className="tro-section-title">Errors</h5>
        <RescoringLegend legendItems={LEGEND_SECTION_READ_MODE} />
        <div className="stats-block">
            {Object.keys(readingStats).map(statItemKey => {
                if (Array.isArray(readingStats[statItemKey])) {
                    return (
                        <div
                            key={generateReactKey(statItemKey)}
                            className={`output-item ${statItemKey}`}
                        >
                            <span>
                                <strong>
                                    {READING_STATS_LABELS[statItemKey]} (
                                    {readingStats[statItemKey].length})
                                </strong>
                            </span>
                            <div className="words-block">
                                {readingStats[statItemKey].map(({ word, isCorrect }, index) => (
                                    <span
                                        key={generateReactKey(index, word)}
                                        className="word d-block"
                                        lang="en"
                                    >
                                        {word} {isCorrect && <i className="icon-v2-edit" />}
                                    </span>
                                ))}
                            </div>
                        </div>
                    );
                }
                return (
                    <span
                        key={generateReactKey(statItemKey)}
                        className={`output-item ${statItemKey.toLowerCase()}`}
                    >
                        <strong>{READING_STATS_LABELS[statItemKey]}: </strong>
                        <span className="correct-word-count">
                            {isUntranscribable ? <i>Not detected</i> : readingStats[statItemKey]}
                        </span>
                    </span>
                );
            })}
        </div>
    </section>
);

ErrorSection.defaultProps = {
    readingStats: {},
    isUntranscribable: false,
};

ErrorSection.propTypes = {
    readingStats: PropTypes.object,
    isUntranscribable: PropTypes.bool,
};

export default ErrorSection;
